export default __webpack_public_path__ + "static/media/colors.705c6d53.jpg";